module.exports = __webpack_public_path__ + "img/xlsx.a4df73be.svg";